import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * EY-branded Aura preset.
 * Primary = EY dark (#2e2e38) with white (#fff) text for contrast.
 * Customizing tokens via definePreset is part of the free/open-source
 * PrimeNG theming system (no Theme Designer license required).
 */
export const EyAuraPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f4f4f5',
      100: '#e4e4e7',
      200: '#c9c9ce',
      300: '#a3a3ab',
      400: '#71717a',
      500: '#2e2e38',
      600: '#292932',
      700: '#22222a',
      800: '#1b1b21',
      900: '#141419',
      950: '#0c0c0f'
    },
    colorScheme: {
      light: {
        primary: {
          color: '#2e2e38',
          contrastColor: '#ffffff',
          hoverColor: '#22222a',
          activeColor: '#1b1b21'
        },
        highlight: {
          background: '#2e2e38',
          focusBackground: '#22222a',
          color: '#ffffff',
          focusColor: '#ffffff'
        }
      },
      dark: {
        primary: {
          color: '#2e2e38',
          contrastColor: '#ffffff',
          hoverColor: '#3a3a46',
          activeColor: '#45454f'
        },
        highlight: {
          background: 'rgba(46, 46, 56, 0.36)',
          focusBackground: 'rgba(46, 46, 56, 0.48)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)'
        }
      }
    }
  }
});
